/**
 * FrontOffice feature flags / app parameters.
 * Override at build time via Vite env (e.g. VITE_BOOKING_VIA_CADDY=true).
 */
function envFlag(name: string, defaultValue = false): boolean {
  const raw = (import.meta.env as Record<string, string | undefined>)[name];
  if (raw === undefined || raw === '') return defaultValue;
  return raw === 'true' || raw === '1' || raw === 'yes';
}

export const appConfig = {
  /**
   * When true, the boutique shopping cart is shown in the header and booking
   * can be driven via the caddy. Currently piercing booking uses an in-flow
   * selection list, not the boutique cart — keep this false until that lands.
   */
  bookingViaCaddy: envFlag('VITE_BOOKING_VIA_CADDY', false),
} as const;
